import 'vue-multiselect/dist/vue-multiselect.min.css'
import '@/assets/styles/multiselect.scss'

import Vue from 'vue'
import Multiselect from 'vue-multiselect'

/* eslint-disable */
Vue.component('v-multiselect', Multiselect)
